import { css, Theme } from '@emotion/react'
import { typography } from '@/styles'

export const styles = (theme: Theme) => ({
  option: {
    main: css`
      font-size: ${typography.sp};
      color: ${theme.colors.secondary.dark};
    `,
  },
})
